import Table from 'react-bootstrap/Table'
import { TeamSpiritTableProvider } from '../context/TeamSpiritTableContext'
import TeamSpiritSpecialRow from './TeamSpiritSpecialRow'
import TeamSpiritMatchRow from './TeamSpiritMatchRow'

export const getCountryHeaderStyle = (
  country,
  activeNationalTeamName,
  getCountryBandStyle,
  tableHeadStyle,
  activeColumnEdge = 'both'
) => {
  const countryBandStyle = getCountryBandStyle(country, tableHeadStyle)
  return country === activeNationalTeamName
    ? {
        ...countryBandStyle,
        backgroundColor: '#fff0df',
        boxShadow:
          activeColumnEdge === 'left'
            ? 'inset 3px 0 0 #000'
            : activeColumnEdge === 'right'
              ? 'inset -3px 0 0 #000'
              : 'inset 3px 0 0 #000, inset -3px 0 0 #000',
      }
    : countryBandStyle
}

const TeamSpiritMatchTable = ({ table }) => {
  const {
    countryGroups,
    timeline,
    perCountryByRowKey,
    activeNationalTeamName,
    styles,
    formatters,
  } = table
  const headerStyle = (country, activeColumnEdge) =>
    getCountryHeaderStyle(
      country,
      activeNationalTeamName,
      table.actions.getCountryBandStyle,
      styles.tableHeadStyle,
      activeColumnEdge
    )

  return (
    <TeamSpiritTableProvider value={table}>
      <div className="table-responsive">
        <Table bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '12px' }}>
          <thead>
            <tr>
              <th title="Kilpailun kierros" style={{ ...styles.tableHeadStyle, width: '84px', minWidth: '84px' }} rowSpan={2}>Kalenteri</th>
              <th title="Ottelupäivä" style={{ ...styles.tableHeadStyle, width: '56px', minWidth: '56px' }} rowSpan={2}>pvm</th>
              {countryGroups.map(country => <th key={country} title={`Joukkue: ${country}`} data-active-national-team={country === activeNationalTeamName || undefined} style={headerStyle(country)} colSpan={2}>{country}</th>)}
            </tr>
            <tr>
              {countryGroups.flatMap(country => [
                <th key={`${country}-attitude`} title="Otteluasenne ja joukkuehenki" data-active-national-team={country === activeNationalTeamName || undefined} style={headerStyle(country, 'left')}>{formatters.t('attitude')}</th>,
                <th key={`${country}-midfield`} title="Keskikenttä, ottelupaikka ja simulointi" data-active-national-team={country === activeNationalTeamName || undefined} style={headerStyle(country, 'right')}>{formatters.t('midfield')}</th>,
              ])}
            </tr>
          </thead>
          <tbody>
            {timeline.map(row => {
              const rowCountryState = perCountryByRowKey[row.key] || {}
              return row.type === 'match'
                ? <TeamSpiritMatchRow key={row.key} row={row} rowCountryState={rowCountryState} />
                : <TeamSpiritSpecialRow key={row.key} row={row} rowCountryState={rowCountryState} />
            })}
          </tbody>
        </Table>
      </div>
    </TeamSpiritTableProvider>
  )
}

export default TeamSpiritMatchTable
